<template>
  <div>
    <h2>Check-In Form Component</h2>
  </div>
</template>

<script>
export default {
  name: 'CheckInForm'
}
</script>
